import { CONSTANTS } from "./constants";

export const CONFIGURATION = {
    CONTACT_TYPE: "AGENT",
    CUSTOMER_TYPE: "RETAIL",
    SEARCH_ALIAS: process.env.REACT_APP_SEARCH_ALIAS.toLowerCase(),
    SEARCH_BRAND_CODE: process.env.REACT_APP_BRAND.toUpperCase(),
    CUSTOM_ROOM_TYPE_CODE: "CUSTOM",
    DATE_FORMAT: "DD MMM YYYY",
    DATE_FORMAT_WITH_WEEK: "ddd, DD MMM YYYY",
    DATE_FORMAT_WITH_TIME: "MMM DD, YYYY H:mm",
    DUE_DATE_FORMAT: "DD-MMM-YY",
    DATE_FORMAT_TIME: "DD-MM-YYYY hh:mm:ss",
    LOADING_SCREEN: 3000,
    MINIMUM_VACATION_DAYS: 8,
    NUMBER_OF_PRODUCTS: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI ? 2 : 3,
    NUMBER_OF_PRODUCTS_IQM: 10,
    NUMBER_OF_ROOM_TYPES: 3,
    PAGE_RECORD_SIZE: 10,
    PAGE_INDEX: 1,
    NUMBER_OF_OPTIONS_ALLOWED: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI ? 2 : 5,
    ENDPOINT_GET_BUSINESS_LOGO: "/Documents/LOGO",
    ENDPOINT_GET_DRAFT_QUOTE_TO_CUSTOMIZE: "?forCustomQuote=true",
    CUSTOM_QUOTE_ITINERARY_PAGE_SIZE: 10,
    CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT: 1000,
    CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT: 100,
    CUSTOM_QUOTE_MARKUP_SURCHARGE_LIMIT: 15,
    CUSTOM_QUOTE_STEP5_TABS: 5,
    DEFAULT_TIMEOUT: 300000,
    FLIGHT_CHECKING_MAX_ATTEMPTS: 0,
    QUOTE_WIZARD_STEP_GROUP_INFO: 1,
    QUOTE_WIZARD_STEP_OPTION_INFO_COLLECTION: 2,
    QUOTE_WIZARD_STEP_FLIGHT_COLLECTION: 3,
    QUOTE_WIZARD_STEP_SUMMARY: 4,
    QUOTE_WIZARD_TOTAL_STEPS: 4,
    SPIN_LOADER_URL: "https://booking-path.assets.sunwingtravelgroup.com/assets/images/loader.min.svg",
    WEST_JET_AIRLINE_LOGO: "https://assets.sunwingtravelgroup.com/image/upload/fl_preserve_transparency/v1727807016/WestJet/BRAND/Logos/WS/WS_CMYK-White%20Behind%20Leaf.jpg?_s=public-apps",
    CUSTOMIZE_QUOTE_ENABLE: true,
    CHECK_CIRCLE_ROUNDED_ICON_IS_OUTLINED: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI,
    SIGN_IN_ENABLE: false,
    GSO_FLIGHT_SEARCH_ENABLE: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI,
    APPLY_DEPARTURE_ICON: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI,
    APPLY_FIELD_ADORNMENT: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI,
    HAS_OWN_DECORATION: process.env.REACT_APP_BRAND === CONSTANTS.BRAND_WVI || process.env.REACT_APP_BRAND === CONSTANTS.BRAND_VWQ
};
